const LoadingCard = () => (
  <article className="px-4 md:w-1/4 w-full pt-4 pb-1">
    <div className="shadow-md">
      <div className="aspect-[3/2] bg-slate-300 animate-pulse w-full" />
      <div className="px-4 py-2.5 h-[84px] overflow-hidden">
        <div className="bg-slate-300 animate-pulse h-3 w-14 rounded-full" />
        <div className="bg-slate-300 mt-1 animate-pulse h-3.5 w-11/12 rounded-full" />
        <div className="bg-slate-300 mt-1 animate-pulse h-3.5 w-11/12 rounded-full" />
      </div>
    </div>
  </article>
)

export default LoadingCard
